/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { contentsRequestCommentControllerCreate } from '../fn/contents-request-comment/contents-request-comment-controller-create';
import { ContentsRequestCommentControllerCreate$Params } from '../fn/contents-request-comment/contents-request-comment-controller-create';
import { contentsRequestCommentControllerDelete } from '../fn/contents-request-comment/contents-request-comment-controller-delete';
import { ContentsRequestCommentControllerDelete$Params } from '../fn/contents-request-comment/contents-request-comment-controller-delete';
import { contentsRequestCommentControllerFindAll } from '../fn/contents-request-comment/contents-request-comment-controller-find-all';
import { ContentsRequestCommentControllerFindAll$Params } from '../fn/contents-request-comment/contents-request-comment-controller-find-all';
import { contentsRequestCommentControllerFindByContentsRequestId } from '../fn/contents-request-comment/contents-request-comment-controller-find-by-contents-request-id';
import { ContentsRequestCommentControllerFindByContentsRequestId$Params } from '../fn/contents-request-comment/contents-request-comment-controller-find-by-contents-request-id';
import { contentsRequestCommentControllerFindById } from '../fn/contents-request-comment/contents-request-comment-controller-find-by-id';
import { ContentsRequestCommentControllerFindById$Params } from '../fn/contents-request-comment/contents-request-comment-controller-find-by-id';
import { contentsRequestCommentControllerSearchCursor } from '../fn/contents-request-comment/contents-request-comment-controller-search-cursor';
import { ContentsRequestCommentControllerSearchCursor$Params } from '../fn/contents-request-comment/contents-request-comment-controller-search-cursor';
import { contentsRequestCommentControllerSearchOffset } from '../fn/contents-request-comment/contents-request-comment-controller-search-offset';
import { ContentsRequestCommentControllerSearchOffset$Params } from '../fn/contents-request-comment/contents-request-comment-controller-search-offset';
import { contentsRequestCommentControllerUpdate } from '../fn/contents-request-comment/contents-request-comment-controller-update';
import { ContentsRequestCommentControllerUpdate$Params } from '../fn/contents-request-comment/contents-request-comment-controller-update';
import { ContentsRequestCommentDto } from '../models/contents-request-comment-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class ContentsRequestCommentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contentsRequestCommentControllerFindAll()` */
  static readonly ContentsRequestCommentControllerFindAllPath = '/api/contents-request-comment';

  /**
   * 콘텐츠 의뢰 코멘트 전체 조회.
   *
   * 콘텐츠 의뢰 코멘트 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestCommentControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestCommentControllerFindAll$Response(params?: ContentsRequestCommentControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContentsRequestCommentDto>>> {
    return contentsRequestCommentControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 코멘트 전체 조회.
   *
   * 콘텐츠 의뢰 코멘트 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestCommentControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestCommentControllerFindAll(params?: ContentsRequestCommentControllerFindAll$Params, context?: HttpContext): Observable<Array<ContentsRequestCommentDto>> {
    return this.contentsRequestCommentControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ContentsRequestCommentDto>>): Array<ContentsRequestCommentDto> => r.body)
    );
  }

  /** Path part for operation `contentsRequestCommentControllerCreate()` */
  static readonly ContentsRequestCommentControllerCreatePath = '/api/contents-request-comment';

  /**
   * 콘텐츠 의뢰 코멘트 생성.
   *
   * 콘텐츠 의뢰 코멘트을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestCommentControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestCommentControllerCreate$Response(params: ContentsRequestCommentControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestCommentDto>> {
    return contentsRequestCommentControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 코멘트 생성.
   *
   * 콘텐츠 의뢰 코멘트을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestCommentControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestCommentControllerCreate(params: ContentsRequestCommentControllerCreate$Params, context?: HttpContext): Observable<ContentsRequestCommentDto> {
    return this.contentsRequestCommentControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestCommentDto>): ContentsRequestCommentDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestCommentControllerSearchOffset()` */
  static readonly ContentsRequestCommentControllerSearchOffsetPath = '/api/contents-request-comment/search/offset';

  /**
   * 콘텐츠 의뢰 코멘트 오프셋 기반 조회.
   *
   * 콘텐츠 의뢰 코멘트을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestCommentControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestCommentControllerSearchOffset$Response(params: ContentsRequestCommentControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return contentsRequestCommentControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 코멘트 오프셋 기반 조회.
   *
   * 콘텐츠 의뢰 코멘트을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestCommentControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestCommentControllerSearchOffset(params: ContentsRequestCommentControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.contentsRequestCommentControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestCommentControllerSearchCursor()` */
  static readonly ContentsRequestCommentControllerSearchCursorPath = '/api/contents-request-comment/search/cursor';

  /**
   * 콘텐츠 의뢰 코멘트 커서 기반 조회.
   *
   * 콘텐츠 의뢰 코멘트을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestCommentControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestCommentControllerSearchCursor$Response(params: ContentsRequestCommentControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return contentsRequestCommentControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 코멘트 커서 기반 조회.
   *
   * 콘텐츠 의뢰 코멘트을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestCommentControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestCommentControllerSearchCursor(params: ContentsRequestCommentControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.contentsRequestCommentControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestCommentControllerFindByContentsRequestId()` */
  static readonly ContentsRequestCommentControllerFindByContentsRequestIdPath = '/api/contents-request-comment/{id}/contentsRequest';

  /**
   * 콘텐츠 의뢰  ID 기반 조회.
   *
   * 콘텐츠 의뢰 코멘트를 콘텐츠 의뢰 ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestCommentControllerFindByContentsRequestId()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestCommentControllerFindByContentsRequestId$Response(params: ContentsRequestCommentControllerFindByContentsRequestId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContentsRequestCommentDto>>> {
    return contentsRequestCommentControllerFindByContentsRequestId(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰  ID 기반 조회.
   *
   * 콘텐츠 의뢰 코멘트를 콘텐츠 의뢰 ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestCommentControllerFindByContentsRequestId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestCommentControllerFindByContentsRequestId(params: ContentsRequestCommentControllerFindByContentsRequestId$Params, context?: HttpContext): Observable<Array<ContentsRequestCommentDto>> {
    return this.contentsRequestCommentControllerFindByContentsRequestId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ContentsRequestCommentDto>>): Array<ContentsRequestCommentDto> => r.body)
    );
  }

  /** Path part for operation `contentsRequestCommentControllerFindById()` */
  static readonly ContentsRequestCommentControllerFindByIdPath = '/api/contents-request-comment/{id}';

  /**
   * 콘텐츠 의뢰 코멘트 ID 기반 조회.
   *
   * 콘텐츠 의뢰 코멘트을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestCommentControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestCommentControllerFindById$Response(params: ContentsRequestCommentControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestCommentDto>> {
    return contentsRequestCommentControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 코멘트 ID 기반 조회.
   *
   * 콘텐츠 의뢰 코멘트을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestCommentControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestCommentControllerFindById(params: ContentsRequestCommentControllerFindById$Params, context?: HttpContext): Observable<ContentsRequestCommentDto> {
    return this.contentsRequestCommentControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestCommentDto>): ContentsRequestCommentDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestCommentControllerDelete()` */
  static readonly ContentsRequestCommentControllerDeletePath = '/api/contents-request-comment/{commentId}';

  /**
   * 콘텐츠 의뢰 코멘트 삭제.
   *
   * 콘텐츠 의뢰 코멘트을(를) 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestCommentControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestCommentControllerDelete$Response(params: ContentsRequestCommentControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestCommentDto>> {
    return contentsRequestCommentControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 코멘트 삭제.
   *
   * 콘텐츠 의뢰 코멘트을(를) 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestCommentControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contentsRequestCommentControllerDelete(params: ContentsRequestCommentControllerDelete$Params, context?: HttpContext): Observable<ContentsRequestCommentDto> {
    return this.contentsRequestCommentControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestCommentDto>): ContentsRequestCommentDto => r.body)
    );
  }

  /** Path part for operation `contentsRequestCommentControllerUpdate()` */
  static readonly ContentsRequestCommentControllerUpdatePath = '/api/contents-request-comment/{commentId}';

  /**
   * 콘텐츠 의뢰 코멘트 수정.
   *
   * 콘텐츠 의뢰 코멘트를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contentsRequestCommentControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestCommentControllerUpdate$Response(params: ContentsRequestCommentControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ContentsRequestCommentDto>> {
    return contentsRequestCommentControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 콘텐츠 의뢰 코멘트 수정.
   *
   * 콘텐츠 의뢰 코멘트를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contentsRequestCommentControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contentsRequestCommentControllerUpdate(params: ContentsRequestCommentControllerUpdate$Params, context?: HttpContext): Observable<ContentsRequestCommentDto> {
    return this.contentsRequestCommentControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ContentsRequestCommentDto>): ContentsRequestCommentDto => r.body)
    );
  }

}
